export const defaultDateFormat = 'yyyy-MM-dd';
export const defaultDateDisplayFormat = 'dd.MM.yyyy';
export const defaultTimeFormat = 'HH:mm';
export const defaultDateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
export const displayDateTimeFormat = 'dd.MM.yyyy HH:mm:ss';
export const displayDateTimeFormatWithoutSecond = 'dd.MM.yyyy HH:mm';
export const dateTimeFormatWithoutSecond = 'yyyy-MM-dd HH:mm';
export const displayDateTimeFormatWithDay = 'HH:mm d/MM/yyyy EEEE';
export const displayDateTimeFormatWithMonth = 'MMMM d HH:mm';
export const displayDateDayFormatWithMonth = 'd MMMM, EEEE';

export const localStorageServerTimeDifference = 'serverTimeDifference';
